const CURRENT_REFINEMENTS_CONDITION_LABEL_OVERRIDES = { "Shows Wear": "Very Good", Worn: "Good" };

document.addEventListener("algolia.hooks.initialize", function () {
  algoliaShopify.hooks.registerHook("beforeISStartAddWidgetArray", function () {
    const { connectRange, connectSortBy } = instantsearch.connectors;
    const { currentRefinements, rangeInput, stats } = instantsearch.widgets;
    const { clearRefinements, configure } = window.algoliaShopify.externals.widgets;
    const currency = window.algoliaShopify.helpers.activeCurrencyCode();
    const currencySymbol = currency === "gbp" ? "£" : "$";
    const isFollowingPage = window.location.pathname === "/pages/following";
    const algoliaPrefix = window.algoliaShopify.config.index_prefix;
    const algoliaSuffix = window.location.host.includes(".co.uk")
      ? "_uk_en"
      : window.location.host.includes("wholesale")
        ? "_wholesale_en"
        : isFollowingPage
          ? ""
          : "_us_active_en";
    const algoliaIndex = `${algoliaPrefix}products${algoliaSuffix}`;
    const isSoldItems = window.location.href.includes("sold-items");

    const items = [
      { label: "Relevance", value: algoliaIndex },
      ...(isSoldItems
        ? []
        : [
            {
              label: "Price (low - high)",
              value: `${algoliaIndex}_price_asc`,
            },
          ]),
      ...(isSoldItems
        ? []
        : [
            {
              label: "Price (high - low)",
              value: `${algoliaIndex}_price_desc`,
            },
          ]),
      {
        label: "Alphabetical (a-z)",
        value: `${algoliaIndex}_title_asc`,
      },
      {
        label: "Alphabetical (z-a)",
        value: `${algoliaIndex}_title_desc`,
      },
      {
        label: "Oldest",
        value: `${algoliaIndex}_published_at_asc`,
      },
      {
        label: "Newest",
        value: `${algoliaIndex}_published_at_desc`,
      },
      ...(isSoldItems
        ? []
        : [
            {
              label: "Best Value",
              value: `${algoliaIndex}_bestvalue_desc`,
            },
          ]),
      ...(isSoldItems
        ? []
        : [
            {
              label: "Recently Marked Down",
              value: `${algoliaIndex}_pricedat_desc`,
            },
          ]),
    ];

    const renderSortBy = (renderOptions, isFirstRender) => {
      const { options, currentRefinement, refine } = renderOptions;
      const container = document.querySelector("#fp-algolia-sort-desktop");
      const matchingSortItem = items.find((elem) => elem.value === currentRefinement) || "";
      let desktopSortButton;
      let mobileSortHeading;
      let currentSortSelected;
      let sortIcon;
      let sortDropdown;
      const downArrowIcon = `<svg width="14" height="14" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" alt="chevron down icon" aria-hidden="true"><path fill="#191C1F" d="m12.8 18.6 10.9-11c.4-.4.4-1.2 0-1.6l-.7-.6c-.4-.4-1.2-.4-1.6 0L12 14.9l-9.4-9.6c-.4-.4-1.2-.4-1.6 0L.3 6c-.4.4-.4 1.2 0 1.6l10.9 11c.4.5 1.2.5 1.6 0"></path></svg>`;
      const upArrowIcon = `<svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none" aria-hidden="true"><path fill="#191C1F" d="m12.8 5.4 10.9 11c.4.4.4 1.2 0 1.6l-.7.6c-.4.4-1.2.4-1.6 0L12 9.1l-9.4 9.6c-.4.4-1.2.4-1.6 0L.3 18c-.4-.4-.4-1.2 0-1.6l10.9-11c.4-.5 1.2-.5 1.6 0"></path></svg>`;

      if (isFirstRender) {
        desktopSortButton = document.createElement("button");
        desktopSortButton.classList.add("fp-sort-button");

        // create heading for mobile sort
        mobileSortHeading = document.createElement("div");
        mobileSortHeading.classList.add("fp-sort-heading");
        mobileSortHeading.innerHTML = `
        <h3 class="fp-sort-header h4">Sort</h3>
        <span class="fp-sort-close">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="24"
            height="24"
            fill="none"
            aria-hidden="true"
            class="fp-primary fp-xs"
          >
            <path
              fill="#191C1F"
              d="m14.5 12 7.7-7.7 1.6-1.6c.2-.2.2-.6 0-.8L22.1.2c-.2-.2-.6-.2-.8 0L12 9.5 2.7.2c-.2-.2-.6-.2-.8 0L.2 1.9c-.2.2-.2.6 0 .8L9.5 12 .2 21.3c-.2.2-.2.6 0 .8l1.7 1.7c.2.2.6.2.8 0l9.3-9.3 7.7 7.7 1.6 1.6c.2.2.6.2.8 0l1.7-1.7c.2-.2.2-.6 0-.8z"
            ></path>
          </svg>
        </span>
        `;

        currentSortSelected = document.createElement("span");
        currentSortSelected.classList.add("fp-current-sort-selected");
        currentSortSelected.innerHTML = matchingSortItem.label;
        sortIcon = document.createElement("span");
        sortIcon.classList.add("fp-sort-icon");
        sortIcon.innerHTML = downArrowIcon;

        desktopSortButton.appendChild(currentSortSelected);
        desktopSortButton.appendChild(sortIcon);
        sortDropdown = document.createElement("div");
        sortDropdown.classList.add("fp-sort-dropdown");

        sortDropdown.addEventListener("click", (event) => {
          const isButtonSelected = event.target.className?.includes("fp-sort-dropdown-item");
          if (!isButtonSelected) {
            return;
          }
          event.preventDefault();
          event.stopPropagation();
          // ensure click event only runs on mobile sort
          if (window.innerWidth < 768) {
            document.querySelector(".fp-sort-open").click();
          }
          refine(event.target.value);
          closeDropdown();
          currentSortSelected.innerHTML = event.target.innerText.trim();
        });

        desktopSortButton.addEventListener("click", (event) => {
          event.preventDefault();
          event.stopPropagation();
          if (sortDropdown.classList.contains("show")) {
            sortDropdown.style.display = "none";
            sortIcon.innerHTML = downArrowIcon;
          } else {
            sortDropdown.style.display = "block";
            sortIcon.innerHTML = upArrowIcon;
          }
          sortDropdown.classList.toggle("show");
        });

        // for close on click-outside
        document.body.addEventListener("click", () => {
          if (sortDropdown.classList.contains("show")) {
            closeDropdown();
          }
        });

        container.appendChild(desktopSortButton);
        container.appendChild(mobileSortHeading);
        container.appendChild(sortDropdown);
      }

      container.querySelector(".fp-sort-dropdown").innerHTML = `
        ${options
          .map(
            (option) => `
              <button
                aria-label="Sort by ${option.label}"
                value="${option.value}"
                class="fp-sort-dropdown-item ${option.value === currentRefinement ? "selected" : ""}"
              >
                ${option.label}
              </button>
            `,
          )
          .join("")}
      `;

      const closeDropdown = () => {
        sortDropdown.style.display = "none";
        sortDropdown.classList.toggle("show");
        sortIcon.innerHTML = downArrowIcon;
      };
    };

    const customSortBy = connectSortBy(renderSortBy);
    const sortByWidgetDesktop = customSortBy({
      items,
    });

    const clearRefinementsWidgetDesktop = clearRefinements({
      container: "#fp-ais-clear-refinements-desktop",
      templates: {
        resetLabel({ hasRefinements }, { html }) {
          return html`${hasRefinements
            ? `<span aria-label="Clear Filters" class="ais-ClearRefinements-button">Clear filters</span>`
            : null}`;
        },
      },
    });

    const clearRefinementsWidgetMobile = clearRefinements({
      container: "#fp-ais-clear-refinements-mobile",
      templates: {
        resetLabel({ hasRefinements }, { html }) {
          return html`${hasRefinements
            ? `<span aria-label="Clear Filters" class="ais-ClearRefinements-button">Clear filters</span>`
            : null}`;
        },
      },
    });

    const currentRefinementsWidgetDesktop = currentRefinements({
      container: "#fp-ais-current-refined-values-desktop",
      transformItems(items) {
        return items.map((item) => {
          if (item.attribute == "inventory_available" || item.attribute == "meta.custom.filters_price_filters") {
            item.refinements.map((refinement) => {
              refinement.label =
                refinement.value === "true"
                  ? "Available Now"
                  : refinement.value === "false"
                    ? "On Hold/Sold"
                    : refinement.label;
              refinement.label = refinement.label.replaceAll("$", currencySymbol);
              return refinement;
            });
          }

          if (item.attribute.includes("condition")) {
            item.refinements.map((refinement) => {
              refinement.label = CURRENT_REFINEMENTS_CONDITION_LABEL_OVERRIDES[refinement.label] ?? refinement.label;
              return refinement;
            });
          }

          return item;
        });
      },
    });

    const currentRefinementsWidgetMobile = currentRefinements({
      container: "#fp-ais-current-refined-values-mobile",
      transformItems(items) {
        return items.map((item) => {
          if (item.attribute == "inventory_available" || item.attribute == "meta.custom.filters_price_filters") {
            item.refinements.map((refinement) => {
              refinement.label =
                refinement.value === "true"
                  ? "Available Now"
                  : refinement.value === "false"
                    ? "On Hold/Sold"
                    : refinement.label;
              refinement.label = refinement.label.replaceAll("$", currencySymbol);
              return refinement;
            });
          }

          if (item.attribute.includes("condition")) {
            item.refinements.map((refinement) => {
              refinement.label = CURRENT_REFINEMENTS_CONDITION_LABEL_OVERRIDES[refinement.label] ?? refinement.label;
              return refinement;
            });
          }

          return item;
        });
      },
    });

    const statsWidget = stats({
      container: "#fp-ais-item-count",
      templates: {
        text(data, { html }) {
          let count = "";

          if (data.hasManyResults) {
            count += `${data.nbHits.toLocaleString("en")} Items`;
          } else if (data.hasOneResult) {
            count += `1 item`;
          } else {
            count += "";
          }

          return html`${count}`;
        },
      },
    });

    const renderRangeInput = (renderOptions, isFirstRender) => {
      const { start, refine, widgetParams } = renderOptions;
      const [min, max] = start;

      if (isFirstRender) {
        const form = document.createElement("form");
        form.classList.add("ais-RangeInput-form");

        const errorDiv = document.createElement("div");
        errorDiv.classList.add("fp-price-range-error-message");

        form.addEventListener("submit", (event) => {
          event.preventDefault();

          window.rawMinInputValue = parseFloat(event.target.elements.min.value);
          window.rawMaxInputValue = parseFloat(event.target.elements.max.value);

          refine([
            Number.isFinite(rawMinInputValue) ? rawMinInputValue : undefined,
            Number.isFinite(rawMaxInputValue) ? rawMaxInputValue : undefined,
          ]);
        });

        widgetParams.container.appendChild(form);
        widgetParams.container.appendChild(errorDiv);

        return;
      }

      widgetParams.container.querySelector("form").innerHTML = `
        <input
          class="ais-RangeInput-input"
          type="number"
          name="min"
          placeholder="Min"
          value="${window.rawMinInputValue ? window.rawMinInputValue : min}"
          />
        <span class="ais-RangeInput-separator"></span>
        <input
          class="ais-RangeInput-input"
          type="number"
          name="max"
          placeholder="Max"
          value="${window.rawMaxInputValue ? window.rawMaxInputValue : max}"
        />
        <button class="ais-RangeInput-submit" type="submit">Apply</button>
      `;
    };

    const customRangeInput = connectRange(renderRangeInput);

    const isSearchPage = window.location.pathname === "/search";
    const collectionDefaultSort = String(window.collectionDefaultSort || "")
      .trim()
      .toLowerCase();
    const collectionSortItem = items.find((elem) => elem.label.toLowerCase() === collectionDefaultSort);
    const defaultSortIndex = collectionSortItem ? collectionSortItem.value : `${algoliaIndex}_published_at_desc`;
    const url = new URL(window.location.href);
    const sortByIndex = url.searchParams.get("sortBy");

    // If there is an invalid sortBy value, refresh the page and set it to the default sort
    const isValidSortBy = items.some((elem) => elem.value === sortByIndex);
    if (sortByIndex && !isValidSortBy) {
      url.searchParams.set("sortBy", defaultSortIndex);
      window.location.replace(url.toString());
      return [];
    }

    const configureWidget = configure({
      index: !!sortByIndex ? sortByIndex : isSearchPage ? algoliaIndex : defaultSortIndex,
    });

    return [
      clearRefinementsWidgetDesktop,
      clearRefinementsWidgetMobile,
      currentRefinementsWidgetDesktop,
      currentRefinementsWidgetMobile,
      sortByWidgetDesktop,
      statsWidget,
      configureWidget,
      customRangeInput({
        container: document.querySelector("#fp-ais-price-range-input"),
        attribute: "price",
      }),
    ];
  });

  algoliaShopify.hooks.registerHook("afterISStartRemoveDefaultWidget", function (defaultWidgets) {
    const defaultStatsWidget = defaultWidgets.find((widget) => widget.$$widgetType === "ais.stats");
    return [defaultStatsWidget];
  });
});

document.addEventListener("algolia.hooks.initialize", () => {
  algoliaShopify.hooks.registerHook("beforeInstantSearchFiltersString", (defaultFilter) => {
    const isSoldItems = window.location.href.includes("sold-items");
    if (isSoldItems) {
      return defaultFilter.replace("inventory_quantity > 0", "inventory_quantity = 0");
    }

    return defaultFilter;
  });
});
